/*
 * DigiFlow Nyc - Quiz Gift
 * Author: Rodrigo Gesser
 * Date: 2024-12-11
*/

(function () {

  //if (window.location.href.includes('pdq-tracking-page')) return;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    try {
      const url = args[0];
      
      // Verifica se a URL é a /cart.js
      if (url.includes('/cart.js')) {
        setBtnView();
        // Faz a requisição original para obter os dados do carrinho
        let response = await originalFetch.apply(this, args);
        let cartData = await response.clone().json();
        let it_arr = [];
        //preenche array com id e qtd de itens do carrinho
        it_arr = cartData.items
          .filter(item => item.properties && item.properties._kit === "essential8")
          .map(item => ({
              id: item.id,
              quantity: item.quantity
          }));

        //total de brindes a serem adicionados
        let ttl_brd = calcularBrindes(it_arr);
       
        //array de
        const ids = [
          { ori_id: 42654354604132, new_id: 51702547120495 },
          { ori_id: 40989151985764, new_id: 51702547153263 },
          { ori_id: 39363311206500, new_id: 51702547186031 },
          { ori_id: 39419786526820, new_id: 51702547218799 },
          { ori_id: 42654362501220, new_id: 51702547251567 },
          { ori_id: 42654366793828, new_id: 51702547284335 },
          { ori_id: 42654377803876, new_id: 51702547317103 }
        ];      
        // Filtrar os itens com _type igual a "Tangent-quiz"
        let quizProducts = cartData.items.filter(item => item.properties && item.properties._kit === "essential8");

        // Se não encontrar produtos essential 8
        if(quizProducts.length === 0){
          return await originalFetch.apply(this, args);
        }else if (quizProducts.length >= 1){
          // Verificar se o item com o ID especificado existe no carrinho
          let gifId =  cartData.items.find(item => item.properties && item.properties._quiz_gift === "free bag");
          //tratar como string
          let quizBag = quizProducts.map(item => item.properties["_quiz-bag"]);

          let bagId = null;
          let newId = null;
          
          // Verifica se quizBag existe e possui itens
          if (quizBag && quizBag.length > 0) {
            //id da bolsa
            bagId = quizBag[0].toString();
  
            // Verifica se bagId está em ids
            const found = ids.find(obj => obj.ori_id.toString() === bagId);
  
            if (found) {
              //Atribui o novo id da bag
              newId = found.new_id;
              // Verifica se o item com o ID especificado existe no carrinho
              // Converte para string, se necessário;
              let bagExist = cartData.items.find(item => String(item.id) === String(newId)); 
              // Converte para string, se necessário;
              let bag = cartData.items.find(item => String(item.id) === String(bagId));
              
              // se a quantidade de brindes for maior que 0 remover bolsas
              if (ttl_brd >= 1) {
                if(bag && gifId){
                  let res = await originalFetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    id: String(bagId),
                    quantity: 0,
                  }),
                });
      
                if (res.ok) {
                    window.dispatchEvent(new Event('THEME:CART_UPDATED'));
                    res = await originalFetch.apply(this, args);
                    
                }
                return res;
                }
              }

              // Verificar se o total de itens do tipo "Tangent-quiz" ultrapassa 3
              if (quizProducts.length >= 4 && !bagExist) {
                // requisição para adicionar o bag
                let res = await originalFetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      id: newId, 
                      quantity: ttl_brd,
                      properties: {
                          _quiz_gift: 'free bag',
                      },
                    }),
                });
              
                if (res.ok) {
                    window.dispatchEvent(new Event('THEME:CART_UPDATED'));
                    res = await originalFetch.apply(this, args);
                }
                return res;
            }

            if (ttl_brd === 0) {
              if( gifId ){
                let res = await originalFetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    id: String(gifId.id),
                    quantity: 0,
                  }),
                });
      
                if (res.ok) {
                  await originalFetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    id: String(bagId),
                    quantity: 1,
                  }),
                });
                  window.dispatchEvent(new Event('THEME:CART_UPDATED'));
                  res = await originalFetch.apply(this, args);
                }
                return res;
              }
            }

            if(gifId.quantity != ttl_brd){
              let res = await originalFetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: String(gifId.id),
                  quantity: ttl_brd,
                }),
              });
    
              if (res.ok) {
                  window.dispatchEvent(new Event('THEME:CART_UPDATED'));
                  res = await originalFetch.apply(this, args);
              }
              return res;
            }  

            }else{
              return await originalFetch.apply(this, args);
            }
          }

        }
      }
      // Continuar com a requisição original
      return await originalFetch.apply(this, args);
    } catch (e) {
      return await originalFetch.apply(this, args);
    }
  };
})();

function calcularBrindes(itens) {
  let totalBrindes = 0;
  try{

    // Expandir os produtos pelo número de quantidades
    const produtosExpandidos = [];
    itens.forEach(item => {
        for (let i = 0; i < item.quantity; i++) {
            produtosExpandidos.push(item.id);
        }
    });
  
    // Contagem de combinações de 4 produtos diferentes
    const contagem = {};
    produtosExpandidos.forEach(id => {
        contagem[id] = (contagem[id] || 0) + 1;
    });
  
    // Obter os IDs das combinações de 4 produtos diferentes
    let idsUnicos = Object.keys(contagem);
 
    // Enquanto for possível agrupar 4 produtos diferentes
    while (idsUnicos.length >= 4) {
        totalBrindes++;
        
        // Remover uma unidade de 4 produtos diferentes
        for (let i = 0; i < 4; i++) {
            const id = idsUnicos[i];
            contagem[id] -= 1;
            if (contagem[id] === 0) {
                idsUnicos.splice(i, 1);
                i--; // Ajustar índice após remoção
            }
        }
    }
    
  }catch(e){
    totalBrindes = 0;
  }finally{
    return totalBrindes;
  }
}



function getCheckouBtn(){
  const btn = document.querySelector('a[href="/checkout"].inline-flex');
  try{

    if(btn){
      return btn;
    }

  }catch(e){
    return null;
  }
}

function getCheckouBtn(){
  const btn = document.querySelector('a[href="/checkout"].inline-flex');
  try{

    if(btn){
      return btn;
    }

  }catch(e){
    return null;
  }
}

let dgf_tmr = null;
function setBtnView(){
  let btn = getCheckouBtn();
  //let spn = 'UPDATING...';
  try{
    if(btn && dgf_tmr === null ){
      btn.classList.add('dgf-loading');
      btn.innerHTML = `<span class="loader"></span>`;
      
      dgf_tmr = setTimeout(() => {
        btn.classList.remove('dgf-loading');
        btn.innerHTML = '';
        btn.innerHTML = 'CHECKOUT';
        clearTimeout(dgf_tmr);
        window.updateTotals();
        dgf_tmr = null;
      }, 4000);


    }
  }catch(e){ null; }
}

// Função para corrigir o texto do botão
function correctButtonText(btn) {
  if (btn && btn.textContent.trim().toLowerCase() === "checkoutcheckout") {
    btn.innerHTML = "";
    btn.textContent = "CHECKOUT";
  }
}

  function observeButtonText() {
    const targetNode = document.body; // Monitorar alterações em todo o corpo do documento

    const observer = new MutationObserver(() => {
      const btn = getCheckouBtn();

      if (btn) {
        // Configuração do observer do botão
        const buttonObserver = new MutationObserver(() => {
          correctButtonText(btn);
        });

        // Iniciar observação do botão
        buttonObserver.observe(btn, { childList: true, subtree: true, characterData: true });

        // Corrigir o texto imediatamente, caso necessário
        correctButtonText(btn);
      }
    });

    // Configuração do observer no DOM
    observer.observe(targetNode, { childList: true, subtree: true });

  }

// Chamar a função para iniciar o processo
document.addEventListener("DOMContentLoaded", observeButtonText);